import {
    FETCH_RULE_REQUEST,
    FETCH_RULE_SUCCESS,
    FETCH_RULE_FAILURE,
    UPDATE_RULE_REQUEST,
    UPDATE_RULE_SUCCESS,
    UPDATE_RULE_FAILURE,
  } from '../actions/types';
  
  const initialState = {
    ruleData: null,
    loading: false,
    error: null,
  };
  
  const ruleDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_RULE_REQUEST:
      case UPDATE_RULE_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_RULE_SUCCESS:
        return {
          ...state,
          ruleData: action.payload,
          loading: false,
        };
      case FETCH_RULE_FAILURE:
      case UPDATE_RULE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      case UPDATE_RULE_SUCCESS:
        return {
          ...state,
          ruleData: action.payload,
          loading: false,
        };
      default:
        return state;
    }
  };
  
  export default ruleDetailsReducer;